import React, { ElementType } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import MaterialUITypography from '../Typography';

type Variant = 'body1' | 'body2' | 'button' | 'caption' | 'h1' | 'h2' | 'h3' |
'h4' | 'h5' | 'h6' | 'inherit' | 'overline' | 'subtitle1' | 'subtitle2';

const body2PropertyTypes = {
  children: PropTypes.node,
  tag: PropTypes.elementType,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    // eslint-disable-next-line max-len
    'body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2',
  ] as Variant[]),
};

type Body2PropertyTypes = InferProps<typeof body2PropertyTypes> & {
  variant?: Variant;
  tag?: ElementType;
  className?: string;
};

const Body2 = ({
  children,
  tag = 'p',
  className,
  variant = 'body2',
  ...properties
} : Body2PropertyTypes) => (
  <MaterialUITypography
    tag={tag}
    className={className}
    variant={variant}
    color="textSecondary"
    {...properties}
  >
    {children}
  </MaterialUITypography>
);

Body2.propTypes = body2PropertyTypes;

const Body2Wrapper = (properties: Body2PropertyTypes) => (
  <Body2 {...properties} />
);

export default Body2Wrapper;
